import { useEffect, useMemo } from 'react';
import { createPortal } from 'react-dom';

const Portal = ({ children, timeout = 0 }) => {
  const $portal = document.querySelector('#portal-root');

  const $el = useMemo(() => {
    return document.createElement('div');
  }, []);

  useEffect(() => {
    $portal.append($el);

    return () => {
      setTimeout(() => {
        $el.remove();
      }, timeout);
    };
  }, [$el, $portal, timeout]);

  return createPortal(children, $el);
};

export default Portal;
